import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
const Button = forwardRef(({ variant = "primary", fullWidth = false, disabled = false, children, onClick, className, rounded = false, ...props }, ref) => {
    const variantClasses = {
        primary: "bg-button-primary text-button-secondary border-button-primary shadow-button hover:shadow-glow",
        "primary-dark": "bg-button-secondary text-button-primary border-0 px-6.5 py-2.5 shadow-button hover:shadow-glow",
        secondary: "bg-button-secondary text-button-primary border-button-primary shadow-button hover:shadow-glow",
        "secondary-dark": "border-button-secondary bg-button-dark text-button-secondary shadow-button hover:shadow-glow",
        tertiary: "bg-[#f3f3f7] text-button-primary border-[#f3f3f7] shadow-button hover:shadow-glow",
    };
    return (_jsx("button", { ref: ref, className: clsx("h-button", {
            "rounded-button px-6 py-2": !rounded,
            "rounded-full aspect-square h-full p-[15px]": rounded,
            "w-full": fullWidth,
            "cursor-not-allowed": disabled,
        }, "border-2", "inline-flex", "items-center", "justify-center", "cursor-pointer", "transition-button", "duration-button", "ease-button", "text-base", "font-medium", "focus:outline-none", "focus-visible:outline-2", "focus-visible:outline-button-focus", "focus-visible:outline-offset-2", "w-fit", disabled && variant === "primary"
            ? "bg-[#f3f3f7] text-[#b4b4bb] border-[#f3f3f7]"
            : variantClasses[variant], className), disabled: disabled, onClick: disabled
            ? undefined
            : onClick, ...props, children: _jsx("span", { className: "!text-inherit whitespace-nowrap flex items-center gap-2", children: children }) }));
});
Button.displayName = "Button";
export default Button;
//# sourceMappingURL=Button.js.map